export const initalLocations = [
  'Bar - Basement',
  'Bar - Dry',
  'Bar - Wet',
  'Bathroom',
  'Bathroom - Basement',
  'Bathroom - Guest',
  'Bathroom - Hall',
  'Bathroom - Master',
  'Bathroom - Powder Room',
  'Butler\'s Pantry',
  'Fireplace Hearth',
  'Fireplace Vertical Cladding',
  'Kitchen',
  'Laundry',
  'Outdoor Grill'];